import { notifications } from "@mantine/notifications";
import * as Sentry from "@sentry/react";

const reloadAppMessage =
  "Network error. Please refresh the page or use 🔄 Reload App.";

export const sendDataAndDirectiveToBobController = async (
  bobUuid: string,
  directive: string,
  data: object,
  url: string,
) => {
  //console.log(data);
  try {
    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content");

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken, // Include the CSRF token in the headers
        },
        body: JSON.stringify({
          bobUuid: bobUuid,
          directive: directive,
          data: data,
        }),
      });
      // console.log("response in send to rails controller", response);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (err) {
      Sentry.captureException(err, {
        tags: {
          function: "sendDataAndDirectiveToBobController",
          action: "fetch_request",
        },
        contexts: {
          request_details: {
            url,
            directive,
            bobUuid,
            data: JSON.stringify(data).substring(0, 500), // Limit data size
            hasCSRFToken: !!csrfToken,
            errorMessage: err?.message || "Unknown error",
          },
        },
      });
      return { success: false, message: reloadAppMessage };
    }
  } catch (err) {
    Sentry.captureException(err, {
      tags: {
        function: "sendDataAndDirectiveToBobController",
        action: "csrf_token_retrieval",
      },
      contexts: {
        request_details: {
          url,
          directive,
          bobUuid,
          data: JSON.stringify(data).substring(0, 500), // Limit data size
          csrfTokenFound: !!document.querySelector('meta[name="csrf-token"]'),
          errorMessage: err?.message || "Unknown error",
        },
      },
    });
    return { success: false, message: reloadAppMessage };
  }
};

export const sendToBobController = async (data: object, url: string) => {
  // console.log(data);

  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute("content");

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken, // Include the CSRF token in the headers
      },
      body: JSON.stringify(data),
    });

    // console.log("response in send to bob controller", response);
    return await response.json();
  } catch (err) {
    console.log("caught error in sendToBobController", err);
    Sentry.captureException(err, {
      tags: {
        function: "sendToBobController",
        action: "fetch_request",
      },
      contexts: {
        request_details: {
          url,
          data: JSON.stringify(data).substring(0, 500), // Limit data size
          hasCSRFToken: !!csrfToken,
          errorMessage: err?.message || "Unknown error",
        },
      },
    });
    return { success: false, message: reloadAppMessage };
  }
};

export const sendToRailsController = async (data: object, url: string) => {
  console.log(data);
  try {
    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content");

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken, // Include the CSRF token in the headers
        },
        body: JSON.stringify(data),
      });
      // console.log("response in send to rails controller", response);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (err) {
      console.error("Error in fetch request:", err);
      Sentry.captureException(err, {
        tags: {
          function: "sendToRailsController",
          action: "fetch_request",
        },
        contexts: {
          request_details: {
            url,
            data: JSON.stringify(data).substring(0, 500), // Limit data size
            hasCSRFToken: !!csrfToken,
            errorMessage: err?.message || "Unknown error",
          },
        },
      });
      // notifications.show({
      //   color: "blue",
      //   title: "Hm, not sure what happened there...",
      //   message:
      //     "If your node is in the process of starting, please try this again after your node is running. If your node is running, please try refreshing the page.",
      // });
      return false;
    }
  } catch (err) {
    console.error("Error retrieving CSRF token:", err);
    Sentry.captureException(err, {
      tags: {
        function: "sendToRailsController",
        action: "csrf_token_retrieval",
      },
      contexts: {
        request_details: {
          data: JSON.stringify(data).substring(0, 500), // Limit data size
          csrfTokenFound: !!document.querySelector('meta[name="csrf-token"]'),
          errorMessage: err?.message || "Unknown error",
        },
      },
    });
    return false;
  }
};
